import type { ValueOf } from '../indexed-access-type';
import { sizes as textSizes, themes as textThemes } from '../text/text.types';
import { variants, sizes } from './visually-button.types';

export const italicMap: Partial<Record<ValueOf<typeof variants>, true>> = {
  cta: true,
  'cta-secondary': true,
  'cta-secondary-white': true,
};

export const sizeMap: Record<keyof typeof sizes, keyof typeof textSizes> = {
  small: textSizes.small,
  basic: textSizes.basic,
  large: textSizes.large,
};

export const themeMap: Record<
  ValueOf<typeof variants>,
  keyof typeof textThemes
> = {
  complete: textThemes.emphasis,
  cta: textThemes.headline,
  'cta-secondary': textThemes.headline,
  'cta-secondary-white': textThemes.headline,
  primary: textThemes.emphasis,
  'primary-destructive': textThemes.emphasis,
  'primary-white': textThemes.emphasis,
  secondary: textThemes.emphasis,
  'secondary-white': textThemes.emphasis,
  'secondary-destructive': textThemes.emphasis,
  tertiary: textThemes.emphasis,
  'tertiary-destructive': textThemes.emphasis,
  'fixed-tertiary': textThemes.emphasis,
  waitlist: textThemes.emphasis,
  'waitlist-secondary': textThemes.emphasis,
};
